<template>
  <div class="grid-container">
    <div
      id="benefits-section"
      class="lh-element-topborder margin-bottom-m"
      :class="benefitsSectionStyle"
    >
      <div class="grid-x">
        <h3
          class="cell padding-bottom-m"
          :class="benefitsHeaderStyle"
          v-html="header"
        ></h3>
        <a
          v-if="brand === 'bcom'"
          href="#exclusions-title"
          class="cell small-6 text-right"
          >{{ EXCLUSION_LINK_TEXT }}</a
        >
      </div>
      <div class="lty-my-benefits-points grid-x grid-padding-x">
        <div
          v-for="(benefit, index) in benefits"
          :key="benefit.id"
          class="lty-my-benefits-point-item cell"
          :class="getBenefitItemClass(index)"
        >
          <div class="text-center padding-bottom-s lty-my-benefits-icon small-3">
            <img
              :src="benefit.benefitSvgPath"
              class="lty-my-benefits-img"
              loading="lazy"
              alt="Benefit Icon"
            />
          </div>
          <div class="text-center large-padding-left-s large-padding-right-s medium-padding-left-xs medium-padding-right-xs small-9">
            <component
              :is="benefitsSubtitleStyle"
              :class="envProps.isMew ? 'text-left' : ''"
              class="lty-my-benefits-heading padding-bottom-xxs"
              @click="handleClickToPointScroll($event, emit)"
            >
              <span v-html="benefit.benefitTitle"></span>
            </component>
            <p
              :class="envProps.isMew ? 'text-left' : ''"
              class="lty-my-benefits-desc body"
              v-text="benefit.benefitDec"
            ></p>
          </div>
        </div>
      </div>
      <div
        v-if="showSeeAllPerksBtn"
        class="grid-x align-center margin-top-m"
      >
        <button
          class="secondary-cta"
          @click="seeAllPerks = !seeAllPerks"
          v-text="seeAllPerks ? 'Show less' : 'See all perks'"
        ></button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';
import { brand, benefitsHeader, benefitsHeaderStyle, benefitsSubtitleStyle, benefitsSectionStyle, TIER_NAME, PERKS_LIST } from '../../config';
import benefitsData from './benefitsList.json';
import { handleClickToPointScroll } from '../../utils/scrollToPointUtil';
import { useLoyaltyHubStore } from '../../stores/useLoyaltyHubStore';
import { useEnvPropsStore } from '../../stores/useEnvPropsStore';
import { useKillswitchesStore } from '../../stores/useKillswitchesStore';

const props = defineProps({
  isAmexEligible: {
    type: Boolean,
    default: true,
  },
});

const EXCLUSION_LINK_TEXT = PERKS_LIST.SEE_EXCLUSIONS;
const seeAllPerks = ref(false);
const header = ref('');

const loyaltyHub = useLoyaltyHubStore();
const envPropsStore = useEnvPropsStore();
const killswitchesStore = useKillswitchesStore();
const envProps = computed(() => envPropsStore.envProps || { isMew: false });
const tierName = computed(() => loyaltyHub.tierName);
const isTriplePointUpgradeEnabled = computed(() => killswitchesStore.triplePointsDayBenefitUpdateEnabled === true);

const showSeeAllPerksBtn = computed(() => brand === 'bcom' && tierName.value !== 'LOYALLIST');

const benefits = computed(() => {
  const memberBenefits = benefitsData?.[brand]?.[tierName.value] || [];
  let bcomSourceBenefits = memberBenefits;

  if (brand === 'bcom' && isTriplePointUpgradeEnabled.value) {
    bcomSourceBenefits = memberBenefits.map((benefit) => {
      if (benefit.benefitDec_ED) {
        return {
          ...benefit,
          benefitDec: benefit.benefitDec_ED,
        };
      }
      return benefit;
    });
  }

  const filteredBenefits = props.isAmexEligible ? bcomSourceBenefits : bcomSourceBenefits.filter((benefit) => benefit.benefitTitle !== 'Amex offers');
  const bcomBenefits = seeAllPerks.value ? filteredBenefits : filteredBenefits.slice(0, 6);
  return brand === 'mcom' ? memberBenefits : bcomBenefits;
});

const getBenefitItemClass = (index) => {
  const columnClasses = envProps.value.isMew ? 'grid-x' : '';
  const marginClassAtIndex = envProps.value.isMew ? 1 : 3;
  const marginTopClass = index >= marginClassAtIndex ? 'margin-top-l' : '';
  return `small-12 medium-4 large-4 ${columnClasses} ${marginTopClass}`;
};

onMounted(() => {
  header.value = benefitsHeader(TIER_NAME[tierName.value]);
});
const emit = defineEmits(['scroll-to-exclusion-details']);
</script>






<style lang="scss" scoped>
.lty-my-benefits-img {
  width: auto;
}
.lty-my-benefits-icon {
  height: rem-calc(65);
}
#benefits-section:deep(sup) {
  cursor: pointer;
}


@import '~@core/csg/src/scss/settings/bcom.scss';
.lty-my-benefits-heading {
  font-size: $h3-font-size;
  line-height: $h3-line-height;
  font-weight: $global-weight-bold;
  letter-spacing: 0.04em;
}
.lty-my-benefits-desc {
  font-size: rem-calc(14);
}
</style>